import type { AbstractClientLogger } from './ClientLogger.no-deps'
import { raceWithTimeout } from './race.no-deps'

export type PromiseThunk = () => Promise<void>

export type PromiseThunkQueue = { push: (thunk: PromiseThunk) => Promise<void> }

/**
 * A queue of thunks that create promises, to be triggered in sequence
 */
export function createPromiseThunkQueue(logger: AbstractClientLogger, timeoutInMs: number): PromiseThunkQueue {
    const queue: PromiseThunk[] = []
    let isLooping = false

    function push(thunk: PromiseThunk) {
        return new Promise<void>((resolve, reject) => {
            queue.push(() => thunk().then(resolve).catch(reject))
            loop()
        })
    }

    async function loop() {
        if (isLooping) return
        isLooping = true

        while (queue.length > 0) {
            try {
                const thunk = queue.shift()
                await raceWithTimeout(timeoutInMs, thunk)
            } catch (error) {
                logger.error(error)
            }
        }

        isLooping = false
    }

    return { push }
}
